module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__;